import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-truncate"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "d-flex w-100" }
const _hoisted_8 = { class: "flex-fill" }
const _hoisted_9 = ["href", "title"]
const _hoisted_10 = {
  key: 1,
  class: "text-success"
}

import {__} from "~/ts/library/Translate";
import StringHelper from "~/ts/library/StringHelper";
import MyRemoteDataTable from "~/cabinet/vue/interface/data/MyRemoteDataTable.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import ReactiveFilterableListOpenApiRequest from "~/core-ui/ts/request/ReactiveFilterableListOpenApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import CopyToClipboardButton from "~/cabinet/vue/interface/CopyToClipboardButton.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed, ref} from 'vue';
import {localeDateTimeString, secondsFormatToClosestFloor} from "~/core-ui/ts/CoreUiHelpersMixin";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalClientInfoDialog',
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    defaultTabId: { default: "info" }
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");

let tabId = ref(props.defaultTabId);
let now = ref(Math.floor((new Date()).getTime() / 1000));

let visitedPages = computed(() => {
    let stat = props.userdata.visitStatistic;
    if (stat) {
        let count = stat.visitedPageCount;
        return StringHelper.getSclon(count, __("Посетил %d страницу", count), __("Посетил %d страницы", count), __("Посетил %d страниц", count));
    }
    return null;
});

let visitedPagesRequest = computed(() => {
    let p: OperatorApplicationApi.OperatorBuddyListGetVisitedPagesContentOpenApiModel = {
        username: props.userdata.username,
        limit: 10
    };
    return (new ReactiveFilterableListOpenApiRequest(
        (new OperatorApiRequest({
            url: "/buddyList/getVisitedPages",
            p
        }))
    ));
});

let canViewReferer = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canViewReferers, props.userdata.siteId);
});


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(isVisible),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(__)('Информация о посетителе'),
    width: "700px",
    class: "dialog-with-tabs-title"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabId),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabId) ? (tabId).value = $event : tabId = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _unref(__)('Информация'),
            name: "info"
          }, null, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _unref(__)('Посещённые страницы'),
            name: "pages"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabId),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(tabId) ? (tabId).value = $event : tabId = $event)),
        class: "dialog-body-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "info" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "150px",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Имя')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.userdata.fields.descr), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Целевой посетитель')
                  }, {
                    default: _withCtx(() => [
                      (__props.userdata.targetReasons.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.userdata.targetReasons, (reason, key) => {
                            return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(reason.reason), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(__)('Нет')), 1)
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (_unref(canViewReferer))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(__)('Источник перехода')
                      }, {
                        default: _withCtx(() => [
                          (!__props.userdata.referer)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(__)('Прямой переход на сайт')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("a", {
                                  href: __props.userdata.referer,
                                  target: "_blank"
                                }, _toDisplayString(__props.userdata.referer), 9, _hoisted_2)
                              ]))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (__props.userdata.visitStatistic && __props.userdata.visitStatistic.firstVisitDateTime)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(__)('Время на сайте')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(__)('Первый заход %s назад.', _unref(secondsFormatToClosestFloor)(_unref(now) - __props.userdata.visitStatistic.firstVisitDateTime))) + " " + _toDisplayString(_unref(visitedPages)) + ". ", 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Первая страница')
                  }, {
                    default: _withCtx(() => [
                      (__props.userdata.firstPage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("a", {
                              href: __props.userdata.firstPage.url,
                              target: "_blank"
                            }, _toDisplayString(__props.userdata.firstPage.title ? __props.userdata.firstPage.title : __props.userdata.firstPage.url), 9, _hoisted_4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Последняя страница')
                  }, {
                    default: _withCtx(() => [
                      (__props.userdata.lastPage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("a", {
                              href: __props.userdata.lastPage.url,
                              target: "_blank"
                            }, _toDisplayString(__props.userdata.lastPage.title ? __props.userdata.lastPage.title : __props.userdata.lastPage.url), 9, _hoisted_6)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            name: "pages",
            lazy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(MyRemoteDataTable, {
                request: _unref(visitedPagesRequest),
                "row-key": "id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    width: "160px",
                    label: _unref(__)('Когда зашёл')
                  }, {
                    default: _withCtx(({row}) => [
                      _createTextVNode(_toDisplayString(_unref(localeDateTimeString)(row.dateTimeOpen)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _unref(__)('Страница')
                  }, {
                    default: _withCtx(({row}) => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: row.url,
                            target: "_blank",
                            title: row.url
                          }, _toDisplayString(row.title), 9, _hoisted_9)
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(CopyToClipboardButton, {
                            content: row.url
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                link: "",
                                title: _unref(__)('Скопировать')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(FontAwesomeIcon, { icon: "copy" })
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    width: "160px",
                    label: _unref(__)('Сколько пробыл')
                  }, {
                    default: _withCtx(({row}) => [
                      (row.dateTimeClose)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(localeDateTimeString)(row.dateTimeClose)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(__)('Ещё не закрыл')), 1))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["request"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})